import {
  DepositIcon,
  HamburgerIcon,
  HistoryIcon,
  LogoutIcon,
  MyProfileIcon,
  StarIcon,
  SwapIcon,
  TransferIcon,
} from "@src/assets";
import { DropdownMenu } from "@src/components";
import { usePrivySmartWallet, useSwapContext } from "@src/contexts";
import { RoutePath } from "@src/interfaces";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export const ControlsDropdownMenu = () => {
  const navigate = useNavigate();
  const { isMultichain, clearSwapStateOnLogout } = useSwapContext();
  const { logout } = usePrivySmartWallet();

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isDropdownShown, setIsDropdownShown] = useState(false);

  const dropdownItems = {
    account: [
      {
        title: "Rewards",
        location: RoutePath.Rewards,
        icon: (
          <StarIcon fill={"var(--swapper-text-color)"} className="w-6 h-6" />
        ),
        onClick: () => {
          navigate(RoutePath.Rewards);
        },
      },
      {
        title: "History",
        location: RoutePath.History,
        icon: <HistoryIcon className="w-6 h-6" />,
        onClick: () => {
          navigate(RoutePath.History);
        },
      },
      {
        title: "My account",
        location: RoutePath.Wallet,
        icon: <MyProfileIcon className="w-6 h-6" />,
        onClick: () => {
          navigate(RoutePath.Wallet);
        },
      },
    ],

    funds: [
      {
        title: "Deposit",
        location: RoutePath.Deposit,
        icon: <DepositIcon className="w-6 h-6" />,
        onClick: () => navigate(RoutePath.Deposit),
      },
      // ...(isMultichain
      //   ? [
      //       {
      //         title: "Move Cash",
      //         location: RoutePath.MoveCash,
      //         icon: <SwapIcon className="w-6 h-6" />,
      //         onClick: () => navigate(RoutePath.MoveCash),
      //       },
      //     ]
      //   : []),
      {
        title: "Transfer",
        location: RoutePath.Transfer,
        icon: <TransferIcon className="w-6 h-6" />,
        onClick: () => navigate(RoutePath.Transfer),
      },
    ],

    other: [
      {
        title: "Log out",
        location: RoutePath.Buy,
        icon: <LogoutIcon className="w-6 h-6" />,
        onClick: () => {
          logout();
          clearSwapStateOnLogout();
          navigate(RoutePath.Buy);
        },
      },
    ],
  };

  const toggleDropdown = () => {
    if (!isDropdownOpen) {
      setIsDropdownOpen(true);
      setTimeout(() => setIsDropdownShown(true), 1);
    } else {
      setIsDropdownShown(false);
      setTimeout(() => setIsDropdownOpen(false), 200);
    }
  };

  return (
    <button
      className={`relative flex gap-1 cursor-pointer ${
        isDropdownOpen && isDropdownShown ? "!fill-theme_color" : ""
      }`}
      onClick={(e) => {
        e.stopPropagation();
        toggleDropdown();
      }}
    >
      <HamburgerIcon
        className={`${
          isDropdownOpen && isDropdownShown ? "!fill-theme_color" : ""
        }`}
      />
      {isDropdownOpen && (
        <DropdownMenu
          isShown={isDropdownShown}
          menuItems={dropdownItems}
          onClose={() => {
            toggleDropdown();
          }}
        />
      )}
    </button>
  );
};
